import './index.module.scss';

import jQuery from 'jquery';

window.jQuery = window.$ = jQuery;
// eslint-disable-next-line import/extensions
require('./vendor/jquery-deparam/jquery-deparam.min.js');
require('./utils/jquery-plugin');

// Note: Because of references to window.$ we need to import this AFTER window.$ is defined above
const AtgJoker = require('./containers/AtgJoker').default;

export default AtgJoker;
